/**
 * Video player section: click-to-play, overlay toggle.
 * - Native video: play/pause, add/remove .video-player--playing on wrapper.
 * - External (YouTube/Vimeo): on first click inject iframe with autoplay, hide poster/overlay.
 */
function getEmbedUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const u = url.trim();
  const youtubeMatch = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
  if (youtubeMatch) {
    return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1&rel=0`;
  }
  const vimeoMatch = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeoMatch) {
    return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
  }
  return null;
}

function initNativeVideo(section) {
  const video = section.querySelector('[data-video-player-video]');
  const playBtn = section.querySelector('[data-video-player-play]');
  const wrapper = section.querySelector('.video-player__wrapper');
  if (!video || !wrapper) return;

  function setPlaying(playing) {
    section.classList.toggle('video-player--playing', playing);
  }

  playBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    video.play();
  });

  wrapper.addEventListener('click', (e) => {
    if (e.target === playBtn || playBtn.contains(e.target)) return;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  video.addEventListener('play', () => setPlaying(true));
  video.addEventListener('pause', () => setPlaying(false));
  video.addEventListener('ended', () => setPlaying(false));
}

function initExternalVideo(section) {
  const url = section.getAttribute('data-video-url');
  const embedUrl = getEmbedUrl(url);
  if (!embedUrl) return;

  const placeholder = section.querySelector('[data-video-player-external-placeholder]');
  const poster = section.querySelector('[data-video-player-poster]');
  const overlay = section.querySelector('[data-video-player-overlay]');
  const playBtn = section.querySelector('[data-video-player-play]');
  const wrapper = section.querySelector('.video-player__wrapper');
  if (!placeholder || !wrapper) return;

  function loadIframe() {
    const iframe = document.createElement('iframe');
    iframe.className = 'video-player__iframe';
    iframe.src = embedUrl;
    iframe.title = 'Video';
    placeholder.appendChild(iframe);
    if (poster) poster.style.display = 'none';
    if (overlay) overlay.style.display = 'none';
    section.classList.add('video-player--playing');
  }

  function handlePlayClick(e) {
    e.preventDefault();
    e.stopPropagation();
    loadIframe();
  }

  playBtn.addEventListener('click', handlePlayClick);
  wrapper.addEventListener('click', (e) => {
    if (e.target === playBtn || playBtn.contains(e.target)) return;
    loadIframe();
  });
}

function initVideoPlayer(section) {
  const type = section.getAttribute('data-video-type');
  if (type === 'native') {
    initNativeVideo(section);
  } else if (type === 'external') {
    initExternalVideo(section);
  }
}

function initVideoPlayers() {
  document.querySelectorAll('[data-video-player]').forEach(initVideoPlayer);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVideoPlayers);
} else {
  initVideoPlayers();
}
